// extracted by mini-css-extract-plugin
export var configurationSection = "_zf-0";